import {
	type CSSProperties,
	forwardRef,
	type InputHTMLAttributes,
	type ReactNode
} from 'react'
import { cn } from '@/helpers/utils'

export interface AnswerItemProps
	extends Omit<InputHTMLAttributes<HTMLInputElement>, 'type'> {
	className?: string
	style?: CSSProperties
	label: ReactNode
	type: 'radio' | 'checkbox'
	inputSize?: 'sm' | 'md'
}

export const AnswerItem = forwardRef<HTMLInputElement, AnswerItemProps>(
	({ className, style, label, inputSize = 'md', ...rest }, ref) => {
		return (
			<label
				className={cn(
					'rounded-xl font-medium text-base text-neutral-700 shadow-xs transition-all',
					inputSize === 'sm'
						? 'rounded-lg px-3 py-2'
						: 'rounded-xl px-4 py-3',
					'ring-1 ring-neutral-300',
					!rest.readOnly && 'cursor-pointer',
					'has-[input:checked]:ring-[3px] has-[input:checked]:ring-neutral-700',
					'has-[input:disabled]:cursor-not-allowed has-[input:disabled]:bg-neutral-100 has-[input:disabled]:text-neutral-500',
					className
				)}
				style={style}
			>
				{label}
				<input ref={ref} {...rest} className='hidden' />
			</label>
		)
	}
)

AnswerItem.displayName = 'AnswerItem'
